import React, { useState, useEffect }  from 'react';

import {Link, useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {db} from '../../firebase'



function Notice () {
   const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
      const [showPerPage, setShowPerPage] = useState(9);
      const [pagination, setPagination] =useState({
          start: 0,
          end: showPerPage,
      });
  
      const onPaginationChange = (start,  end) =>{
          setPagination({start: start, end: end});
      };
      const [searchTerm, setsearchTerm] = useState("");
      const [announce, setAnnounce] = useState([])
      const navigate = useNavigate()
  
      const announceCollectionRef = collection(db, "NOTICE-HOME-RIGHT-TO-LEFT");
      useEffect(() => {
  
          const getAnnounce = async () => {
              const data = await getDocs(announceCollectionRef);
              setAnnounce(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
          }
  
          getAnnounce()
      }, [])
  return (
    <div>

{announce.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } {
        return val;
      }
    }).slice(pagination.start, pagination.end).map((theskillfoundation) => { return (
       
       
                       
                            <div className="card-body">
                                   
                                   <marquee>
      <center>
        <div className="textcolor">
        <h5 style={{ color: "black" }} className='mt-2'><b>{theskillfoundation.title}</b></h5>
        </div>
        </center>
      
      </marquee>
                              
                            </div>
                           
                                )})} 
                            
                            {/* <PaginationOld showPerPage={showPerPage} 
                onPaginationChange={onPaginationChange}
                total={announce.length}
                /> */}
      
    </div>
  )
}

export default Notice
